/*
 * Copyright (c) 2021-2022. Revo Digital
 * ---
 * Author: gabriele
 * File: ZoomControls.tsx
 * Project: mle-client-n
 * Committed last: 2022/1/18 @ 930
 * ---
 * Description:
 */


import { Tooltip2 }           from '@blueprintjs/popover2';
import {
  Button,
  ButtonGroup,
  NavbarGroup,
  PopoverPosition
}                             from '@blueprintjs/core';
import React, { useCallback } from 'react';
import { observer }           from 'mobx-react';
import {
  Editor
}                             from '../../../store/observables/Editor';

interface ZoomControlsProps {
  editor: Editor;
}

export const ZoomControls = observer((props: ZoomControlsProps) => {
  const zoomFeature = props.editor.zoom();

  const resetZoom = useCallback(() => {
    zoomFeature.resetZoom();
  }, [ zoomFeature.zoom ]);

  const incrementZoom = useCallback(() => {
    zoomFeature.incrementZoom();
  }, [ zoomFeature.zoom ]);

  const decrementZoom = useCallback(() => {
    zoomFeature.decrementZoom();
  }, [ zoomFeature.zoom ]);

  return (
    <NavbarGroup>
      <ButtonGroup>
        <Tooltip2 content={ 'Ripristina zoom' }
                  position={ PopoverPosition.BOTTOM }>
          <Button
            small
            icon="maximize"
            onClick={ resetZoom }
          />
        </Tooltip2>
        <Tooltip2 content={ 'Diminuisci zoom' }
                  position={ PopoverPosition.BOTTOM }>
          <Button
            small
            icon="zoom-out"
            onClick={ decrementZoom }
            disabled={ !zoomFeature.canDecrement }
          />
        </Tooltip2>

        <div
          className="bp4-fill text-center px-2 pt-1 bg-bpgray-300 bg-opacity-20">
          { Math.round(zoomFeature.zoom * 100) }%
        </div>

        <Tooltip2 content={ 'Aumenta zoom' }
                  position={ PopoverPosition.BOTTOM }>
          <Button
            small
            icon="zoom-in"
            onClick={ incrementZoom }
            disabled={ !zoomFeature.canIncrement }
          />
        </Tooltip2>
      </ButtonGroup>
    </NavbarGroup>
  );
});
